import React from 'react';
import { AppBar, Toolbar, Typography, Box, IconButton, Menu, MenuItem, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ClearUser } from '../../redux/userSlice';

const Navbar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const dispatch = useDispatch();

  const userLogout = async () => {
    localStorage.removeItem('userToken');
    localStorage.removeItem("userID");
    dispatch(ClearUser());
    window.location.reload();
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMobileMoreAnchorEl(null);
  };

  const handleUserMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = 'primary-search-account-menu';
  const mobileMenuId = 'primary-search-account-menu-mobile';

  return (
    <Box>
      <AppBar position="fixed" sx={{ zIndex: theme.zIndex.drawer + 1, bgcolor: 'black' }}>
        <Toolbar>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            Admission Portal
          </Typography>
          {isMobile ? (
            <Box>
              <IconButton
                size="large"
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                id={mobileMenuId}
                anchorEl={mobileMoreAnchorEl}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                keepMounted
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={isMobileMenuOpen}
                onClose={handleClose}
                PaperProps={{
                  style: {
                    backgroundColor: 'black',
                    color: 'white',
                  },
                }}
              >
                <MenuItem component={Link} to="/home" onClick={handleClose}>
                  Home
                </MenuItem>
                <MenuItem component={Link} to="/user" onClick={handleClose}>
                  User
                </MenuItem>
                <MenuItem component={Link} to="/ageChart" onClick={handleClose}>
                  Age Guide
                </MenuItem>
                <MenuItem onClick={userLogout}>
                  Logout
                </MenuItem>
              </Menu>
            </Box>
          ) : (
            <Box>
              <Menu
                id={menuId}
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={isMenuOpen}
                onClose={handleClose}
                PaperProps={{
                  style: {
                    backgroundColor: 'black',
                    color: 'white',
                  },
                }}
              >
                <MenuItem component={Link} to="/home" onClick={handleClose}>
                  Home
                </MenuItem>
                <MenuItem component={Link} to="/user" onClick={handleClose}>
                  User
                </MenuItem>
                <MenuItem component={Link} to="/ageChart" onClick={handleClose}>
                  Age Guide
                </MenuItem>
                <MenuItem onClick={userLogout}>
                  Logout
                </MenuItem>
              </Menu>
              <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleUserMenu}
                color="inherit"
              >
                <MoreVertIcon />
              </IconButton>
            </Box>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Navbar;
